import type { ProductStatusInfo } from "../hooks"

export const getStatusOverlayText = (
  statusInfo: ProductStatusInfo | undefined
): string | undefined => {
  if (!statusInfo) return undefined

  const shouldShowOverlay =
    statusInfo.status === "out-of-stock" || statusInfo.status === "blocked"

  return shouldShowOverlay ? statusInfo.statusDescription : undefined
}
